var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "black",
    fillOpacity: 0.28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0091 24.6705C17.0508 25.0441 17.2292 25.3978 17.516 25.6819L25.1994 33.3188C25.5612 33.7038 26.0897 33.9468 26.665 33.9922C27.2403 34.0377 27.8139 33.8828 28.2524 33.5632C28.6926 33.2421 28.9594 32.7847 28.9961 32.2932C29.0311 31.8017 28.831 31.3187 28.4408 30.955L21.9445 24.5L28.4408 18.045C28.831 17.6813 29.0311 17.1983 28.9961 16.7068C28.9611 16.2153 28.6926 15.7578 28.2541 15.4368C27.8139 15.1172 27.242 14.9623 26.665 15.0078C26.0897 15.0532 25.5612 15.2962 25.1994 15.6811L17.516 23.3181C17.1391 23.6917 16.9557 24.1804 17.0091 24.6705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.710072627216883ac2f39df249303b50.svg";
export { ForwardRef as ReactComponent };